import React from 'react';

import { THREE_D, TWO_D } from '../types/dimensions';

import 'style/configurator/DimensionToggle.css';

const DimensionToggle = ({
  dimensionStatus,
  setDimensionStatus,
}: {
  dimensionStatus: string;
  setDimensionStatus: (status: string) => void;
}): JSX.Element => {
  const toggleDimensionStatus = () => {
    setDimensionStatus(dimensionStatus === TWO_D ? THREE_D : TWO_D);
  };

  return (
    <div className="dimension-toggle">
      <div className="dimension-toggle-2d-title">
        <p>2D</p>
      </div>
      <div>
        <label className="switch" htmlFor="dimension-toggle-input">
          <input
            checked={dimensionStatus === TWO_D}
            id="dimension-toggle-input"
            onChange={toggleDimensionStatus}
            type="checkbox"
          />
          <span className="slider round" />
        </label>
      </div>
      <div className="dimension-toggle-3d-title">
        <p>3D</p>
      </div>
    </div>
  );
};

export default DimensionToggle;
